import { DeviceResponseType } from "../Devices/IDevice";
import { EnergyMeasurementParameter, FloodSensorStates, MovementStateEnum } from "../Devices/IDeviceState";

export interface IAvailableState {
    get StateObjectType(): string;
    get StateInterfaceType(): string;
    get StateResponseType(): DeviceResponseType;
}

export interface IAvailableStatePerChannel {
    get DeviceGuid(): string;
    get Channel(): number;
    get AvailableStates(): IAvailableState[];
}

export enum StateInterval {
    None = 0,
    DataRange = 1,
    Hour = 2,
    Day = 3,
    Week = 4,
    Month = 5,
    Year = 6,
    // new ones
    ThisHour = 7,
    ThisDay = 8,
    ThisWeek = 9,
    ThisMonth = 10,
    ThisYear = 11,
}


export enum DataRangeType {
    Day = 0,
    Week = 1,
    Month = 2,
    Year = 3,
    Hour = 4
}

export enum AggregateDataType {
    Min = "Min",
    Max = "Max",
    Avg = "Avg"
}

export class AvailableState implements IAvailableState {
    private _objectType: string = "Unknown";
    private _stateInterfaceType: string = "Unknown";

    get StateObjectType(): string {
        return this._objectType;
    }
    get StateInterfaceType(): string {
        return this._stateInterfaceType;
    }
    get StateResponseType(): DeviceResponseType {
        return this._stateInterfaceType as DeviceResponseType;
    }

    set StateObjectType(value: string) {
        this._objectType = value;
    }
    set StateInterfaceType(value: string) {
        this._stateInterfaceType = value;
    }
}

export class StateDataResponse<T> {
    DeviceGuid: string = "";
    DeviceChannel: number = 0;
    Count: number = 0;
    IsNextPageAvailable: boolean = false;
    Limit: number = 0;
    Offset: number = 0;
    Data: StateData<T>[] = [];
    AggregateDataList: AggregateDataEntry[] = [];
}

export class AggregateDataEntry {
    DataEntryIdentity: string = "";
    AggregateData: Map<AggregateDataType, any> = new Map<AggregateDataType, any>();
}

export class StateData<T> {
    Time: string = "";
    Values: T | null = null;
    AggregatedBy: string = "";
}

export interface AveragingStateValues {
    get LastValue(): number;
    get Average(): number;
    get Mode(): number;
    get Min(): number;
    get Max(): number;
}

export interface BrightnessHistory {
    get LuxValue(): number;
    get LuxToLinearScale(): number;
    get LightCondition(): LightCondition;
}

export enum LightCondition {
    Unknown = -1,
    PitchBlack = 0,
    VeryDark = 1,
    DarkIndoors = 2,
    DimIndoors = 3,
    NormalIndoors = 4,
    BrightIndoors = 5,
    DimOutdoors = 6,
    CloudyOutdoors = 7,
    DirectSunlight = 8
}

export interface ReedStateHistory {
    get State(): boolean;
}

export interface FloodStateHistory {
    get State(): FloodSensorStates;
}

export interface MovementStateHistory {
    get Movement(): MovementStateEnum;
    get Intensity(): number;
}

export interface EnergyHistory {
    get MeasurementAveragingParameters(): Map<EnergyMeasurementParameter, AveragingStateValues>;
    get MeasurementNonAveragingParmeters(): Map<EnergyMeasurementParameter, number>;
}